import { Card, Grid, Typography } from "@material-ui/core";
import clsx from "clsx";
import { useStyle } from "./toggle-slot.styles";

interface Props {
  title?: string;
  content: string | JSX.Element;
  footer?: string;
  isSelected?: boolean;
  onClick(): void;
  isBig?: boolean;
}

interface WrapperProps {
  children: string | JSX.Element;
  className: string;
}

const Wrapper = ({ children, ...props }: WrapperProps) => {
  if (typeof children === "string")
    return <Typography {...props}>{children}</Typography>;

  return <Grid {...props}>{children}</Grid>;
};

function ToggleSlot({
  title,
  content,
  footer,
  isSelected,
  onClick,
  isBig,
}: Props) {
  const classes = useStyle();
  return (
    <Card
      onClick={onClick}
      className={clsx(classes.container, {
        [classes.selected]: isSelected,
        [classes.small]: title === "",
        [classes.big]: isBig,
      })}
    >
      {title && <Typography className={classes.title}>{title}</Typography>}
      <Wrapper className={classes.content}>{content}</Wrapper>
      {footer && <Typography className={classes.footer}>{footer}</Typography>}
    </Card>
  );
}

ToggleSlot.defaultProps = {
  title: "",
  footer: "",
  isSelected: false,
  isBig: false,
};

export default ToggleSlot;
